const pluralize = (count, singular, plural) =>
  `${count} ${count === 1 ? singular : plural}`;

const ScheduleGroupRow = ({ row }) => {
  const groupId = row.id ?? row.name ?? "unassigned";
  const total = row.summary?.total ?? row.activityIds?.length ?? 0;
  const needsAttention = row.summary?.needsAttention ?? 0;
  const critical = row.summary?.critical ?? 0;

  return (
    <article
      className="schedule-group-row"
      data-testid={`schedule-group-${row.groupBy}-${groupId}`}
    >
      <div>
        <strong>{row.name}</strong>
        <span>{pluralize(total, "atividade", "atividades")}</span>
      </div>
      <div className="schedule-group-metrics">
        <span>{needsAttention} precisa de atuação</span>
        <span>{pluralize(critical, "crítica", "críticas")}</span>
      </div>
    </article>
  );
};

export default ScheduleGroupRow;
